import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Record from './pages/Record';
import StaffCallPlanner from './pages/staff/CallPlanner';
import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { useTheme, View } from '@aws-amplify/ui-react';
import Logo from './components/Logo';
import awsConfig from '../aws-exports';
import VolunteerRoute from './wrapper/VolunteerRoutes';
import StaffRoute from './wrapper/StaffRoutes';
import AdminRoute from './wrapper/AdminRoutes';
import StaffLayout from './pages/staff/StaffLayout';
import Dashboard from './pages/staff/Dashboard';
import StaffRecord from './pages/staff/Record';
import Settings from './pages/staff/Settings';
import Unauthorized from "./pages/Unauthorized";

Amplify.configure(awsConfig);

interface ComponentsType {
  Header: () => JSX.Element;
}

const components: ComponentsType = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large} backgroundColor={'#fff'}>
        <center><Logo /></center>
      </View>
    );
  }
};

interface AppProps {
  hideSignUp?: boolean;
}

const App: React.FC<AppProps> = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<VolunteerRoute><Home /></VolunteerRoute>} />
          <Route path="/record/:id" element={<VolunteerRoute><Record /></VolunteerRoute>} />
          <Route path="/staff" element={<StaffRoute><StaffLayout /></StaffRoute>}>
            <Route index element={<StaffRoute><Dashboard /></StaffRoute>} />
            <Route path="callplanner" element={<StaffRoute><StaffCallPlanner  /></StaffRoute>} />
            <Route path="staffcalls" element={<StaffRoute><StaffCallPlanner  /></StaffRoute>} />
            <Route path="record/:id" element={<StaffRoute><StaffRecord /></StaffRoute>} />
            <Route path="settings" element={<AdminRoute><Settings /></AdminRoute>} />
            <Route path="unauthorized" element={<Unauthorized />} />
          </Route>
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
      </Router>
    </>
  );
};

export default withAuthenticator(App, {
  hideSignUp: true,
  components
});